import { createContext, Dispatch, useReducer } from 'react';

export type Role =
  | 'ROLE_OWNER'
  | 'ROLE_ADMINISTRATOR'
  | 'ROLE_FINANCE'
  | 'ROLE_SALES_CS'
  | 'ROLE_TECHNICAL'
  | 'ROLE_READ_ONLY';

export interface InvitationState {
  fullName: string;
  email: string;
  role: Role;
  loading: boolean;
}

const initialState: InvitationState = {
  fullName: '',
  email: '',
  role: 'ROLE_OWNER',
  loading: false,
};

interface InvitationAction {
  type: InvitationActionType;
  payload: Partial<InvitationState>;
}

export enum InvitationActionType {
  SET_FULL_NAME = 'SET_FULL_NAME',
  SET_EMAIL = 'SET_EMAIL',
  SET_ROLE = 'SET_ROLE',
  SET_LOADING = 'SET_LOADING',
}

function reducer(state: InvitationState, action: InvitationAction): InvitationState {
  switch (action.type) {
    case InvitationActionType.SET_FULL_NAME:
      return { ...state, fullName: action.payload.fullName || '' };
    case InvitationActionType.SET_EMAIL:
      return { ...state, email: action.payload.email || '' };
    case InvitationActionType.SET_ROLE:
      return { ...state, role: action.payload.role || 'ROLE_OWNER' };
    case InvitationActionType.SET_LOADING:
      return { ...state, loading: action.payload.loading || false };
    default:
      return state;
  }
}

type InvitationContextType = {
  state: InvitationState;
  dispatch: Dispatch<InvitationAction>;
};

export const InvitationContext = createContext<InvitationContextType>({ state: initialState, dispatch: () => {} });

export const InvitationProvider = ({ children }: { children: React.ReactNode }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return <InvitationContext.Provider value={{ state, dispatch }}>{children}</InvitationContext.Provider>;
};
